// Copyright © 2021 Move Closer
export var ContactTabType;
(function (ContactTabType) {
    ContactTabType["ContactData"] = "contactData";
    ContactTabType["ContactForm"] = "contactForm";
    ContactTabType["Location"] = "location";
})(ContactTabType || (ContactTabType = {}));
